import { defineComponent as _defineComponent } from 'vue'
import FormatDateActionFields from '@/components/format-edit/FormatDateActionFields.vue'
import { useLetterFormatData } from '@/composables/format-edit/useLetterFormatData'


export default /*#__PURE__*/_defineComponent({
  __name: 'LetterCreateDateCard',
  props: {
    currentCardId: null
  },
  setup(__props: any) {



const formatData = useLetterFormatData()

return { __sfc: true,formatData, FormatDateActionFields }
}

})